import React from 'react';
import { verifyRegnoListString } from 'utils/strings';
import Warning from 'jsx/elements/messages/Warning';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

import { api } from 'api';
import Modal from './Modal';
import MonitoringInsertResult from './MonitoringInsertResult';
import PortfolioUpdateModalHeader from './PortfolioUpdateModalHeader';

export default function PortfolioRegnoUpdateModal({ monitorId, closeModal }) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const { t } = useLocale();

  async function save() {
    dispatch({ type: 'START_SAVING' });
    const { invalidRegnos, allRegnos } = verifyRegnoListString(state.regnoText);
    if (invalidRegnos.length > 0) {
      dispatch({ type: 'INVALID_REGNOS', payload: invalidRegnos });
      return;
    }
    const res = await api.monitor.addRegnosToMonitor({ monitorId, regnos: allRegnos });
    if (!res.error) {
      dispatch({ type: 'SAVE_SUCCESS', payload: res });
    } else {
      dispatch({ type: 'SAVE_ERROR' });
    }
  }

  return (
    <Modal
      header={t('portfolioUpdateModal_regno_title')}
      onCancelClick={closeModal}
      onConfirmClick={save}
      disableActions={state.saving}
      disableSubmit={state.regnoText === ''}
      isOpen
    >
      <PortfolioUpdateModalHeader key={state.insertResult} monitorId={monitorId} />
      <MonitoringInsertResult
        data={state.insertResult}
        isOpen={state.insertResult !== null}
        onClose={() => dispatch({ type: 'CLOSE_INSERT_RESULT' })}
      />
      {state.invalidRegnos !== null && (
        <Warning
          extraClass="gutter-top"
          messageType="alert"
          messageHeader={t('portfolioMonitoring_uploadBox_invalidRegnos_header')}
          messageBody={t(
            'portfolioMonitoring_uploadBox_invalidRegnos_body',
            state.invalidRegnos.join(', ')
          )}
          onClose={() => dispatch({ type: 'CLEAR_INVALID_REGNOS' })}
        />
      )}
      <div className="text-semibold gutter-top">
        1. {t('portfolioMonitoring_uploadBox_textInput_title')}
      </div>
      <div className="text-14" style={{ paddingLeft: 20 }}>
        <span>{t('portfolioMonitoring_uploadBox_textInput_tip')}</span>
        <div className="form" style={{ maxWidth: 300, marginTop: 10 }}>
          <textarea
            placeholder={t('portfolioMonitoring_uploadBox_textInput_placeholder')}
            style={{ resize: 'none' }}
            onChange={(e) => dispatch({ type: 'UPDATE_REGNOS', payload: e.target.value })}
            value={state.regnoText}
            disabled={state.saving}
          />
        </div>
      </div>
      <div className="text-semibold gutter-top">{t('portfolioUpdateModal_regno_2')}</div>
      <div className="text-14" style={{ paddingLeft: 20 }}>
        {t('portfolioUpdateModal_regno_2_main')}
        <div>
          <a
            href={t('portfolioUpdateModal_regno_2_rulesUrl')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('portfolioUpdateModal_regno_2_rules')}
          </a>
        </div>
      </div>
    </Modal>
  );
}

const initialState = {
  saving: false,
  regnoText: '',
  invalidRegnos: null,
  insertResult: null,
  showError: false,
};

function reducer(state, { type, payload }) {
  switch (type) {
    case 'CLOSE_INSERT_RESULT':
      return { ...state, insertResult: initialState.insertResult };
    case 'UPDATE_REGNOS':
      return { ...state, regnoText: payload };
    case 'INVALID_REGNOS':
      return { ...state, saving: false, invalidRegnos: payload };
    case 'CLEAR_INVALID_REGNOS':
      return { ...state, invalidRegnos: initialState.invalidRegnos };
    case 'START_SAVING':
      return {
        ...state,
        saving: true,
        invalidRegnos: null,
        insertResult: null,
        showError: false,
      };
    case 'SAVE_SUCCESS':
      return { ...initialState, saving: false, insertResult: payload };
    case 'SAVE_ERROR':
      return { ...state, saving: false, showError: true };
    default:
      return state;
  }
}
